import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Admin render error', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <main className="workspace-main">
          <section className="panel">
            <header className="panel-heading">
              <span className="index-label">ERROR / 01</span>
            </header>
            <div className="panel-body">
              <h1>Something went wrong</h1>
              <p>{this.state.error.message}</p>
              <button className="button button-default" type="button" onClick={() => this.setState({ error: null })}>
                Try again
              </button>
            </div>
          </section>
        </main>
      );
    }
    return this.props.children;
  }
}
